// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.countdown-step .countdown-indicator
{
	padding-bottom: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/widgets/Survey/Steps/CountdownStep.css"],"names":[],"mappings":";AACA;;CAEC,oBAAoB;AACrB","sourcesContent":["\n.countdown-step .countdown-indicator\n{\n\tpadding-bottom: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
